export const getInitials = (first: string, last: string) => {
  return `${first.charAt(0)}${last.charAt(0)}`;
};
